<!--begin::Wrapper-->
<div class="card card-flush">
  <div class="card-header">
    <h5 class="card-title fw-bold">Date range</h5>
  </div>
  <div class="card-body">
    <!--begin::Form-->
    <form [formGroup]="rangeTemplateForm">
      <div class="d-flex flex-row">
        <div [ngClass]="isCustom === true ? 'flex-equal' : 'flex-row-fluid'">
          <mat-radio-group formControlName="range">
            <div class="d-flex flex-row" (click)="$event.stopPropagation()">
              @if (allOptions) {
                <div class="d-flex flex-row">
                  <div class="d-flex flex-column">
                    <mat-radio-button value="1">Last 24 Hours</mat-radio-button>
                    <mat-radio-button value="2">Last 7 Days</mat-radio-button>
                    <mat-radio-button value="3">Last 30 Days</mat-radio-button>
                  </div>
                  <div class="d-flex flex-column">
                    <mat-radio-button value="4">Last 90 Days</mat-radio-button>
                    <mat-radio-button value="5">Last 365 Days</mat-radio-button>
                    <mat-radio-button value="6">Custom</mat-radio-button>
                  </div>
                </div>
              }
              @if (!allOptions) {
                <div>
                  <div class="d-flex flex-column">
                    <mat-radio-button value="1">Last 24 Hours</mat-radio-button>
                    <mat-radio-button value="2">Last 7 Days</mat-radio-button>
                    <mat-radio-button value="3">Last 30 Days</mat-radio-button>
                    <mat-radio-button value="6">Custom</mat-radio-button>
                  </div>
                </div>
              }
            </div>
          </mat-radio-group>
        </div>
        @if (isCustom === true) {
          <div class="flex-equal ms-6">
            <div class="d-flex flex-column">
              <div>
                <ngb-datepicker #dp (click)="$event.stopPropagation()"
                  (dateSelect)="onDateSelection($event)"
                  [displayMonths]="2"
                  [dayTemplate]="t"
                  outsideDays="hidden"
                  [maxDate]="maxDate">
                </ngb-datepicker>
              </div>
              @if (allowTime) {
                <div class="d-flex flex-row">
                  <div class="flex-equal flex-center">
                    <ngb-timepicker (click)="$event.stopPropagation()" formControlName="startTime" [meridian]="true"></ngb-timepicker>
                  </div>
                  <div class="flex-equal flex-center">
                    <ngb-timepicker (click)="$event.stopPropagation()" formControlName="endTime" [meridian]="true"></ngb-timepicker>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </form>

    <!--end::Form-->
  </div>
  <div class="card-footer">
    <div class="card-toolbar">
      <button type="button" class="btn btn-secondary me-2"
        (click)="cancel()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary"
        (click)="applyRangeValue()">
        Apply
      </button>
    </div>
  </div>
</div>
<!--end::Wrapper-->

<ng-template #t let-date let-focused="focused">
  <span class="custom-day"
    [class.focused]="focused"
    [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>

